export const referential = {
  error: {
    "condition-ratings": "Le référentiel de cote d'état n'a pu être chargé!",
  },
};
